export default {
  name: 'eventSuspect',
  options: {
    menuIndex: 2,
    isHidden: true,
  },
};
